// extracted by mini-css-extract-plugin
module.exports = {"contentMargin":"ProjectCreateContent_contentMargin__f5JLK","mobileView":"ProjectCreateContent_mobileView__yUaeo"};